/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// structure
import { Division, Subhead, InContentMessage } from '@insticator/insticator-ui'; // iui-material
// pages
import LibraryPage from 'pages/dashboard/reports/library/library_container';
import DetailPage from 'pages/dashboard/reports/detail/detail_container';
import PreviewPage from 'pages/dashboard/reports/preview/preview_container';
// utils
import { Switch, Redirect } from 'react-router';
import { PrivateRoute, setLocalStorage } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/reports_styles';



/* ========== ~~~~~~~~~~ REPORTS SECTION ~~~~~~~~~~ ========== */
class Reports extends Component {
    componentDidMount() {
        // set local storage
        setLocalStorage('newupdate'); // need to extend this new update stuff so we can have multiple new updates potentially
        // get client report data
        if (!this.props.isDataReceived) this.props.getClientReportsData(this.props.accountUUID);
    }
    handleReportName = () => {
        switch (this.props.currentPage) {
            case 'dashboard/reports/detail':
            case 'dashboard/reports/preview':
                return <span className={`uniquename reportname`}>/ {this.handleReportMode()}</span>;
            case 'dashboard/reports':
            default:
                return null;
        }
    };
    handleReportMode = () => {
        switch (this.props.reportMode) {
            case 'library':
            case 'edit':
            case 'preview':
                return this.props.reportName !== "" ? this.props.reportName : 'Report Name';
            case 'create':
                return this.props.reportName !== "" ? this.props.reportName : 'New Report';
            default:
                return null;
        }
    };
    render() {
        return(
            <Division name={`reports`} klass={this.props.classes.reports}>
                <Subhead>
                    <h1>Reports {this.handleReportName()}</h1>
                </Subhead>
                <InContentMessage />
                <Switch>
                    {/*Routes to subsections*/}
                    <PrivateRoute permitted={this.props.reportsPermitted} exact path='/dashboard/reports' component={LibraryPage} />
                    <PrivateRoute permitted={this.props.reportsPermitted && this.props.isDataReceived} redirectTo='/dashboard/reports/' exact path='/dashboard/reports/detail' component={DetailPage} />
                    <PrivateRoute permitted={this.props.reportsPermitted && this.props.isDataReceived} redirectTo='/dashboard/reports/' exact path='/dashboard/reports/preview' component={PreviewPage} />
                    <Redirect to='/error/404' />
                </Switch>
            </Division>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Reports);

